// eslint-disable-next-line css-modules/no-unused-class
import styles from './FormFields.module.css';

interface FixedFieldParams {
	field: string | number;
	label: string;
	button?: JSX.Element;
	testId?: string;
}

export function FixedField({ field, label, button, testId }: FixedFieldParams) {
	return (
		<div className={styles.fixedField} data-testid={testId}>
			<div className={styles.labelTitle} data-testid={`${testId}-label`}>
				{label}
			</div>
			<div className={styles.fixedFieldContainer}>
				<div className={styles.IonFieldText} data-testid={`${testId}-value`}>
					{field}
				</div>
				{button && button}
			</div>
		</div>
	);
}
